module.exports = __webpack_public_path__ + "img/pricing-hero.e98006d3.webp";